import request from '@/utils/request'

// 查询小程序功能开关列表
// 说明：后端接口使用白名单方式注册（appFunctionSwitch.listAppFunctionSwitches），
// 不依赖 c_service / c_route 配置，返回结构为 { total, records, functionSwitches: [] }
export function listAppFunctionSwitches(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/appFunctionSwitch.listAppFunctionSwitches',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve({
        data: res.functionSwitches || [],
        total: res.total || 0
      })
    }).catch(error => {
      reject(error)
    })
  })
}

// 修改小程序功能开关（openFlag: 1 开放 / 0 关闭）
export function updateAppFunctionSwitch(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/appFunctionSwitch.updateAppFunctionSwitch',
      method: 'post',
      data
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}
